<template>
  <div class="cad_block">
    <div class="left">
      <h3 class="large_black_label">代表的なCADファイル形式に対応。</h3>
      <p>プラットフォーム上でCADデータなどの受け渡しが可能。</p>
      <p>クライアントとCADオペレーターとのやり取りはチャット形式を採用。</p>
      <p>わかりやすくスムーズなコミュニケーションを実現しました。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/top/cad.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CadBlock",
  }
</script>

<style lang="scss" scoped>
  .cad_block {
    @include double_columns(40%, 40%);

    > .right .base_image {
      width: 70%;
    }

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>